import { EnumCuponCategoria, EnumTipoCodigoCupon } from "../settings/enumConfig";

export const getModelCupon = () => ({
    fiIdCupon: 0,
    fiIdCuponCategoria: EnumCuponCategoria.DescuentoMonto,
});

export const getFormCupon = () => ({
    rdCuponCodigo: {
        label: ["Código personalizado", "Código aleatorio"],
        required: true,
        value: EnumTipoCodigoCupon.personalizado,
        error: false,
        message: "Seleccione el tipo de generación de código de cupón",
    },
    txtCodigoCupon: {
        label: "Código personalizado:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un código de al menos 6 dígitos",
    },
    txtLongitudCupon: {
        label: "Total de caracteres:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese la longitud de caractéres del cupón",
    },
    txtTipoCupon: {
        label: "Tipo de cupón:",
        required: true,
        value: EnumCuponCategoria.DescuentoMonto,
        error: false,
        message: "Seleccione el tipo de cupón",
    },
    txtMontoDescuento: {
        label: "Monto de descuento:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un monto válido para el descuento",
    },
    txtPorcentajeDescuento: {
        label: "Porcentaje de descuento:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un porcentaje válido para el descuento",
    },
    txtTotalCupones: {
        label: "Total de códigos:",
        required: true,
        value: "",
        error: false,
        message: "Especifíque el total de cupones",
    },
    txtDiasActivos: {
        label: "Días activos:",
        required: true,
        value: "",
        error: false,
        message: "Especifíque los días activos del cupón",
    },
    txtDescripcion: {
        label: "Descripción:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese una descripción para el cupón",
    },
});

export const getFormFiltroCupon = () => ({
    txtTipoCupon: {
        label: "Tipo de cupón:",
        value: "",
    },
    txtVigente: {
        label: "Cupón vigente:",
        value: "",
    },
});

export const getCuponColumns = () => [
    { title: "", field: "sStatus", hideFilter: true, hideSort: true },
    { title: "Código", field: "fsCodigo" },
    { title: "Monto descuento", field: "sMontoDescuento" },
    { title: "Porcentaje descuento", field: "sPorcentajeDescuento" },
    { title: "Total", field: "fiTotalLanzamiento" },
    { title: "Canjeado", field: "fiTotalCanjeado" },
    { title: "Creado", field: "sFechaCreacion" },
    { title: "Vencimiento", field: "sFechaVencimiento" },
];
